import { createSelector } from "reselect"
import { initialState } from "./reducer"

/**
 * Direct selector to the recommendations state domain
 */

const selectRecommendationsDomain = (state) =>
  state.get("recommendations", initialState)

/**
 * Other specific selectors
 */
export const makeSelectIsLoading = () =>
  createSelector(selectRecommendationsDomain, (state) => state.get("isLoading"))

export const makeSelectRecommendationsList = () =>
  createSelector(selectRecommendationsDomain, (state) =>
    state.get("recommendations")
  )

export const makeSelectDimensionsList = () =>
  createSelector(selectRecommendationsDomain, (state) =>
    state.get("dimensions")
  )
/**
 * Default selector used by Recommendations
 */

const makeSelectRecommendations = () =>
  createSelector(selectRecommendationsDomain, (substate) => substate.toJS())

export default makeSelectRecommendations
export { selectRecommendationsDomain }
